/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-sections.reducer';

export const SurveySectionsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveySectionsEntity = useAppSelector(state => state.surveySections.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveySectionsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveySections.detail.title">SurveySections</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveySections.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.id}</dd>
          <dt>
            <span id="sectionName">
              <Translate contentKey="tinyMedicRestApp.surveySections.sectionName">Section Name</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.sectionName}</dd>
          <dt>
            <span id="sectionTitle">
              <Translate contentKey="tinyMedicRestApp.surveySections.sectionTitle">Section Title</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.sectionTitle}</dd>
          <dt>
            <span id="sectionSubheading">
              <Translate contentKey="tinyMedicRestApp.surveySections.sectionSubheading">Section Subheading</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.sectionSubheading}</dd>
          <dt>
            <span id="sectionRequired">
              <Translate contentKey="tinyMedicRestApp.surveySections.sectionRequired">Section Required</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.sectionRequired ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveySections.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveySections.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveySections.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveySections.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveySections.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveySectionsEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveySections.surveyHeader">Survey Header</Translate>
          </dt>
          <dd>{surveySectionsEntity.surveyHeader ? surveySectionsEntity.surveyHeader.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/survey-sections" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-sections/${surveySectionsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveySectionsDetail;
